import { StarsButton as Button } from '@ps/web-shared-components';
import type React from 'react';

import { TXTCLI_Confirm, TXTWCL_Cancel } from '../../translations';

import styles from './ConfirmButton.module.scss';

interface Props {
  onCancel?: () => void;
  onConfirm?: () => void;
}

const ConfirmButton: React.FC<Props> = ({ onCancel, onConfirm }) => (
  <div className={styles.wrap}>
    <Button variant="secondary" translation={TXTWCL_Cancel} size="small" onClick={onCancel} />
    <Button variant="primary" translation={TXTCLI_Confirm} size="small" onClick={onConfirm} />
  </div>
);

export default ConfirmButton;
